
import { concat, ofArray, exists, tryFind, sum, length as length_1, item, head, sortBy, ofSeq, filter, empty, cons, reverse, scan, map as map_1, fold } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { tryFind as tryFind_1, filter as filter_1, FSharpMap__get_Item, containsKey, find, toList, FSharpMap__get_Values, map, add } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { Optic_Map, Optic_Map_op_HatPercent_Z1462312A, Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";
import { DrawModelType_BusWireT_Model, DrawModelType_BusWireT_Wire, DrawModelType_BusWireT_ASegment, DrawModelType_SymbolT_Model, DrawModelType_SymbolT_Symbol, DrawModelType_BusWireT_wires_, DrawModelType_BusWireT_symbol_, DrawModelType_SymbolT_symbols_ } from "../Model/DrawModelType.js";
import { XYPos_$reflection, Edge, Component, BoundingBox, XYPos } from "../Common/CommonTypes.js";
import { max, min } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { List_distinct, List_distinctBy, List_groupBy } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { compare, comparePrimitives, safeHash, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { ofList } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { MapModule_ValuesL } from "../Common/EEExtensions.js";
import { Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { record_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";

export const Constants_intervalTolerance = 0.0001;

/**
 * Update BusWire model with given symbols. Can also be used to add new symbols.
 * This uses a fold on the Map to add symbols which makes it fast in the case that the number
 * of symbols added is very small.
 */
export function updateModelSymbols(model, symbols) {
    const symbols$0027 = fold((symMap, symToAdd) => add(symToAdd.Id, symToAdd, symMap), model.Symbol.Symbols, symbols);
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_symbols_)(DrawModelType_BusWireT_symbol_))(symbols$0027)(model);
}

/**
 * Update BusWire model with given wires. Can also be used to add new wires.
 * This uses a fold on the Map to add wires which makes it fast in the case that the number
 * of wires added is small.
 */
export function updateModelWires(model, wiresToAdd) {
    return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_BusWireT_wires_)((wireMap) => fold((wireMap_1, wireToAdd) => add(wireToAdd.WId, wireToAdd, wireMap_1), wireMap, wiresToAdd))(model);
}

export function moveSymbol(offset, sym) {
    let bind$0040_1, left_1, right_1, bind$0040;
    let newPos;
    const left = sym.Pos;
    const right = offset;
    newPos = (new XYPos(left.X + right.X, left.Y + right.Y));
    return new DrawModelType_SymbolT_Symbol(newPos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, (bind$0040_1 = sym.LabelBoundingBox, new BoundingBox((left_1 = sym.LabelBoundingBox.TopLeft, (right_1 = offset, new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y))), bind$0040_1.W, bind$0040_1.H)), sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, (bind$0040 = sym.Component, new Component(bind$0040.Id, bind$0040.Type, bind$0040.Label, bind$0040.InputPorts, bind$0040.OutputPorts, newPos.X, newPos.Y, bind$0040.H, bind$0040.W, bind$0040.SymbolInfo, bind$0040.SlotInfo)), sym.Annotation, sym.Moving, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText);
}

export function moveSymbols(offset, model) {
    return new DrawModelType_SymbolT_Model(map((_arg, symbol) => moveSymbol(offset, symbol), model.Symbols), model.CopiedSymbols, model.Ports, model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane);
}

/**
 * Returns true if two 1D line segments intersect
 * HLP23: Derek Lai (ddl20)
 */
export function overlap1D(_arg2_, _arg2__1, _arg1_, _arg1__1) {
    const _arg = [_arg2_, _arg2__1];
    const _arg_1 = [_arg1_, _arg1__1];
    const a2 = _arg[1];
    const a1 = _arg[0];
    const b2 = _arg_1[1];
    const b1 = _arg_1[0];
    const matchValue = min(a1, a2);
    const matchValue_1 = max(a1, a2);
    const matchValue_2 = min(b1, b2);
    const matchValue_3 = max(b1, b2);
    if (matchValue_1 >= matchValue_2) {
        return matchValue_3 >= matchValue;
    }
    else {
        return false;
    }
}

/**
 * Converts a segment list into a list of vertices to store inside Connection
 */
export function segmentsToIssieVertices(segList, wire) {
    return map_1((tupledArg_1) => {
        const pos = tupledArg_1[0];
        return [pos.X, pos.Y, tupledArg_1[2]];
    }, scan((tupledArg, seg) => {
        const currPos = tupledArg[0];
        const patternInput = (tupledArg[1] === "vertical") ? [new XYPos(currPos.X, currPos.Y + seg.Length), "horizontal"] : [new XYPos(currPos.X + seg.Length, currPos.Y), "vertical"];
        return [patternInput[0], patternInput[1], seg.Mode === "manual"];
    }, [wire.StartPos, wire.InitialOrientation, false], segList));
}

/**
 * Returns true if two Boxes intersect, where each box is passed in as top right and bottom left XYPos tuples
 * HLP23: Derek Lai (ddl20)
 */
export function overlap2D(_arg2_, _arg2__1, _arg1_, _arg1__1) {
    const _arg = [_arg2_, _arg2__1];
    const _arg_1 = [_arg1_, _arg1__1];
    const a2 = _arg[1];
    const a1 = _arg[0];
    const b2 = _arg_1[1];
    const b1 = _arg_1[0];
    if (overlap1D(a1.X, a2.X, b1.X, b2.X)) {
        return overlap1D(a1.Y, a2.Y, b1.Y, b2.Y);
    }
    else {
        return false;
    }
}

/**
 * Returns true if two Boxes intersect, where each box is passed in as a BoundingBox
 * HLP23: Derek Lai (ddl20)
 */
export function overlap2DBox(bb1, bb2) {
    const bb1Coords = [new XYPos(bb1.TopLeft.X, bb1.TopLeft.Y), new XYPos(bb1.TopLeft.X + bb1.W, bb1.TopLeft.Y + bb1.H)];
    const bb2Coords = [new XYPos(bb2.TopLeft.X, bb2.TopLeft.Y), new XYPos(bb2.TopLeft.X + bb2.W, bb2.TopLeft.Y + bb2.H)];
    return overlap2D(bb1Coords[0], bb1Coords[1], bb2Coords[0], bb2Coords[1]);
}

/**
 * Return absolute segment list from a wire.
 * NB - it is often more efficient to use various fold functions (foldOverSegs etc)
 */
export function getAbsSegments(wire) {
    return reverse(fold((tupledArg, seg_1) => {
        let position, length;
        const posDir = tupledArg[0];
        let nextASeg;
        const _arg = posDir;
        const seg = seg_1;
        const start = _arg[0];
        nextASeg = (new DrawModelType_BusWireT_ASegment(start, (position = start, (length = seg.Length, (_arg[1] === "vertical") ? (new XYPos(position.X, position.Y + length)) : (new XYPos(position.X + length, position.Y)))), seg));
        return [[nextASeg.End, (posDir[1] === "vertical") ? "horizontal" : "vertical"], cons(nextASeg, tupledArg[1])];
    }, [[wire.StartPos, wire.InitialOrientation], empty()], wire.Segments)[1]);
}

/**
 * Return absolute segment list from a wire.
 * NB - it is often more efficient to use various fold functions (foldOverSegs etc)
 */
export function getNonZeroAbsSegments(wire) {
    return reverse(fold((tupledArg, seg_1) => {
        let position, length;
        const posDir = tupledArg[0];
        const aSegL = tupledArg[1];
        let nextASeg;
        const _arg = posDir;
        const seg = seg_1;
        const start = _arg[0];
        nextASeg = (new DrawModelType_BusWireT_ASegment(start, (position = start, (length = seg.Length, (_arg[1] === "vertical") ? (new XYPos(position.X, position.Y + length)) : (new XYPos(position.X + length, position.Y)))), seg));
        const posDir$0027 = [nextASeg.End, (posDir[1] === "vertical") ? "horizontal" : "vertical"];
        if (!(Math.abs(seg_1.Length) < 1E-07)) {
            return [posDir$0027, cons(nextASeg, aSegL)];
        }
        else {
            return [posDir$0027, aSegL];
        }
    }, [[wire.StartPos, wire.InitialOrientation], empty()], wire.Segments)[1]);
}

/**
 * Return filtered absolute segment list from a wire.
 * includeSegment determines whether a given segment is included in the output list.
 * NB this is more efficient than generating the whole lits and then filtering.
 */
export function getFilteredAbsSegments(includeSegment, wire) {
    return reverse(fold((tupledArg, seg_1) => {
        let position, length;
        const _arg_1 = tupledArg[0];
        const aSegL = tupledArg[1];
        const ori = _arg_1[1];
        let nextASeg;
        const _arg = [_arg_1[0], ori];
        const seg = seg_1;
        const start = _arg[0];
        nextASeg = (new DrawModelType_BusWireT_ASegment(start, (position = start, (length = seg.Length, (_arg[1] === "vertical") ? (new XYPos(position.X, position.Y + length)) : (new XYPos(position.X + length, position.Y)))), seg));
        const posDir$0027 = [nextASeg.End, (ori === "vertical") ? "horizontal" : "vertical"];
        if (includeSegment(ori, seg_1)) {
            return [posDir$0027, cons(nextASeg, aSegL)];
        }
        else {
            return [posDir$0027, aSegL];
        }
    }, [[wire.StartPos, wire.InitialOrientation], empty()], wire.Segments)[1]);
}

/**
 * Retrieves XYPos of every vertex in a wire
 * HLP23: Derek Lai (ddl20)
 */
export function getWireSegmentsXY(wire) {
    return map_1((l) => (new XYPos(l[0], l[1])), map_1((tupledArg) => [tupledArg[0], tupledArg[1]], segmentsToIssieVertices(wire.Segments, wire)));
}

/**
 * Retrieves all wires which intersect an arbitrary bounding box & the index
 * of the segment which intersects the box
 * HLP23: Derek Lai (ddl20)
 */
export function getWiresInBox(box, model) {
    const bottomRight = new XYPos(box.TopLeft.X + box.W, box.TopLeft.Y + box.H);
    return map_1((tupledArg_2) => [tupledArg_2[1], tupledArg_2[0][1]], filter((l) => l[0][0], map_1((w) => {
        let wire;
        return [(wire = w, fold((tupledArg, seg) => {
            let state, overlap;
            const currState = tupledArg[0];
            const currPos = tupledArg[1];
            const currOrientation = tupledArg[2];
            const nextOrientation = (currOrientation === "vertical") ? "horizontal" : "vertical";
            if (Math.abs(seg.Length) < 1E-07) {
                return [currState, currPos, nextOrientation];
            }
            else {
                let nextPos;
                const position = currPos;
                const length = seg.Length;
                nextPos = ((currOrientation === "vertical") ? (new XYPos(position.X, position.Y + length)) : (new XYPos(position.X + length, position.Y)));
                return [(state = currState, (overlap = overlap2D(currPos, nextPos, box.TopLeft, bottomRight), [state[0] ? true : overlap, overlap ? seg.Index : state[1]])), nextPos, nextOrientation];
            }
        }, [[false, -1], wire.StartPos, wire.InitialOrientation], wire.Segments)[0]), w];
    }, ofSeq(FSharpMap__get_Values(model.Wires)))));
}

/**
 * Used to fix bounding box with negative width and heights
 * HLP23: Derek Lai (ddl20)
 */
export function fixBoundingBox(box) {
    return new BoundingBox(new XYPos(min(box.TopLeft.X + box.W, box.TopLeft.X), min(box.TopLeft.Y + box.H, box.TopLeft.Y)), Math.abs(box.W), Math.abs(box.H));
}

export function partitionWiresIntoNets(model) {
    return List_groupBy((tupledArg) => tupledArg[1].OutputPort, toList(model.Wires), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
}

/**
 * Moves a wire by the XY amounts specified by displacement
 */
export function moveWire(wire, displacement) {
    let left, right;
    return new DrawModelType_BusWireT_Wire(wire.WId, wire.InputPort, wire.OutputPort, wire.Color, wire.Width, wire.Segments, (left = wire.StartPos, (right = displacement, new XYPos(left.X + right.X, left.Y + right.Y))), wire.InitialOrientation);
}

export function moveWires(offset, model) {
    return new DrawModelType_BusWireT_Model(model.Symbol, map((_arg, wire) => moveWire(wire, offset), model.Wires), model.CopiedWires, model.SelectedSegment, model.LastMousePos, model.ErrorWires, model.Notifications, model.Type, model.ArrowDisplay, model.SnapToNet);
}

/**
 * Returns the center coordinates of a Symbol
 */
export function getSymbolPos(symbolModel, compId) {
    return find(compId, symbolModel.Symbols).Pos;
}

/**
 * The copied symbols in the order SymbolUpdate.pasteSymbols creates new symbols from them.
 * This ordering is load-bearing: pasteSymbols returns the new component ids in this order, and
 * pasteWires pairs old with new by position in the two lists to find the equivalent ports.
 * Both sides must therefore agree - they did not between July 2025 (when the sort below was
 * added to pasteSymbols alone, the two having previously shared plain Map order) and the fix
 * that added this function, during which pasting connected components could attach a wire to
 * the wrong component or drop it.
 */
export function copiedSymbolsInPasteOrder(symModel) {
    return sortBy((sym) => sym.Pos.Y, map_1((tuple) => tuple[1], toList(symModel.CopiedSymbols)), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
}

/**
 * Interface function to get componentIds of the copied symbols
 */
export function getCopiedSymbols(symModel) {
    return map_1((sym) => sym.Id, copiedSymbolsInPasteOrder(symModel));
}

/**
 * Get the start and end positions of a wire.
 * HLP23: AUTHOR Jian Fu Eng (jfe20)
 */
export function getStartAndEndWirePos(wire) {
    const wireVertices = map_1((tupledArg) => (new XYPos(tupledArg[0], tupledArg[1])), segmentsToIssieVertices(wire.Segments, wire));
    return [head(wireVertices), item(length_1(wireVertices) - 2, wireVertices)];
}

/**
 * Returns length of wire
 * HLP23: AUTHOR Jian Fu Eng (jfe20)
 */
export function getWireLength(wire) {
    return fold((acc, seg) => (acc + Math.abs(seg.Length)), 0, wire.Segments);
}

/**
 * Gets total length of a set of wires.
 * HLP23: AUTHOR dgs119
 */
export function totalLengthOfWires(conns) {
    return sum(map_1((tuple) => tuple[1], toList(map((_arg, wire) => getWireLength(wire), conns))), {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    });
}

/**
 * Checks if a wire is part of a net.
 * If yes, return the netlist. Otherwise, return None
 * HLP23: AUTHOR Jian Fu Eng (jfe20)
 */
export function isWireInNet(model, wire) {
    return tryFind((tupledArg) => {
        if (equals(wire.OutputPort, tupledArg[0])) {
            return exists((tupledArg_1) => !equals(tupledArg_1[0], wire.WId), tupledArg[1]);
        }
        else {
            return false;
        }
    }, partitionWiresIntoNets(model));
}

/**
 * Checks if a port is part of a Symbol.
 * HLP23: AUTHOR dgs119
 */
export function isPortInSymbol(portId, symbol) {
    return containsKey(portId, symbol.PortMaps.Orientation);
}

/**
 * Get pairs of unique symbols that are connected to each other.
 * HLP23: AUTHOR dgs119
 */
export function getConnSyms(wModel) {
    return List_distinctBy((tupledArg_1) => ofList(ofArray([tupledArg_1[0], tupledArg_1[1]]), {
        Compare: (x, y) => (compare(x, y) | 0),
    }), filter((tupledArg) => !equals(tupledArg[0].Id, tupledArg[1].Id), map_1((wire) => {
        let model, model_1;
        return [(model = wModel, FSharpMap__get_Item(model.Symbol.Symbols, FSharpMap__get_Item(model.Symbol.Ports, wire.OutputPort).HostId)), (model_1 = wModel, FSharpMap__get_Item(model_1.Symbol.Symbols, FSharpMap__get_Item(model_1.Symbol.Ports, wire.InputPort).HostId))];
    }, MapModule_ValuesL(wModel.Wires))), {
        Equals: (x_1, y_1) => x_1.Equals(y_1),
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    });
}

/**
 * Checks if wire is connected to two given symbols.
 * Returns false if two Symbols are the same.
 * HLP23: AUTHOR dgs119
 */
export function isConnBtwnSyms(wire, symA, symB) {
    const outId = wire.OutputPort;
    const inId = wire.InputPort;
    if (isPortInSymbol(inId, symA) && isPortInSymbol(outId, symB)) {
        return true;
    }
    else if (isPortInSymbol(inId, symB) && isPortInSymbol(outId, symA)) {
        return true;
    }
    else {
        return false;
    }
}

/**
 * Gets connections between symbols.
 * HLP23: AUTHOR dgs119
 */
export function connsBtwnSyms(wModel, symA, symB) {
    return filter_1((_arg, wire) => isConnBtwnSyms(wire, symA, symB), wModel.Wires);
}

/**
 * Gets Wires between symbols.
 * HLP23: AUTHOR dgs119
 */
export function wiresBtwnSyms(wModel, symA, symB) {
    return MapModule_ValuesL(connsBtwnSyms(wModel, symA, symB));
}

/**
 * Filters Ports by Symbol.
 * HLP23: AUTHOR dgs119
 */
export function filterPortBySym(ports, sym) {
    return filter((port) => equals(port.HostId, sym.Id), ports);
}

/**
 * Gets Ports From a List of Wires.
 * HLP23: AUTHOR dgs119
 */
export function portsOfWires(model, wires) {
    return List_distinct(concat(map_1((wire) => ofArray([FSharpMap__get_Item(model.Symbol.Ports, wire.InputPort), FSharpMap__get_Item(model.Symbol.Ports, wire.OutputPort)]), wires)), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
}

/**
 * Groups Wires by the net they belong to.
 * HLP23: AUTHOR dgs119
 */
export function groupWiresByNet(conns) {
    return map_1((arg) => map_1((tuple_1) => tuple_1[1], arg[1]), List_groupBy((tupledArg) => tupledArg[1].OutputPort, toList(conns), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }));
}

/**
 * Scales a symbol so it has the provided height and width.
 * HLP23: AUTHOR BRYAN TAN
 */
export function setCustomCompHW(h, w, sym) {
    return new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, sym.LabelBoundingBox, sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, sym.Component, sym.Annotation, sym.Moving, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, w / sym.Component.W, h / sym.Component.H, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText);
}

/**
 * For a wire and a symbol, return the edge of the symbol that the wire is connected to.
 * /// HLP23: AUTHOR BRYAN TAN
 */
export function wireSymEdge(wModel, wire, sym) {
    const matchValue = FSharpMap__get_Item(wModel.Symbol.Ports, wire.OutputPort);
    const matchValue_1 = FSharpMap__get_Item(wModel.Symbol.Ports, wire.InputPort);
    const sEdge = tryFind_1(matchValue.Id, sym.PortMaps.Orientation);
    const tEdge = tryFind_1(matchValue_1.Id, sym.PortMaps.Orientation);
    let matchResult, e, e_1;
    if (sEdge == null) {
        if (tEdge != null) {
            matchResult = 1;
            e_1 = tEdge;
        }
        else {
            matchResult = 2;
        }
    }
    else if (tEdge == null) {
        matchResult = 0;
        e = sEdge;
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return e;
        case 1:
            return e_1;
        default:
            return Edge.Top;
    }
}

/**
 * Type used to simplify BoundingBox intersection calculations
 */
export class Rectangle extends Record {
    constructor(TopLeft, BottomRight) {
        super();
        this.TopLeft = TopLeft;
        this.BottomRight = BottomRight;
    }
}

export function Rectangle_$reflection() {
    return record_type("BlockHelpers.Rectangle", [], Rectangle, () => [["TopLeft", XYPos_$reflection()], ["BottomRight", XYPos_$reflection()]]);
}

/**
 * Checks if 2 rectangles intersect
 */
export function rectanglesIntersect(rect1, rect2) {
    const intersect1D = (xOrY) => {
        const qHi = min(xOrY(rect1.BottomRight), xOrY(rect2.BottomRight));
        return max(xOrY(rect1.TopLeft), xOrY(rect2.TopLeft)) <= qHi;
    };
    if (intersect1D((pos) => pos.X)) {
        return intersect1D((pos_2) => pos_2.Y);
    }
    else {
        return false;
    }
}

export function findPerpendicularDistance(segStart, segEnd, point) {
    if (Math.abs(segStart.X - segEnd.X) > Math.abs(segStart.Y - segEnd.Y)) {
        return Math.abs(segStart.Y - point.Y);
    }
    else {
        return Math.abs(segStart.X - point.X);
    }
}

/**
 * Checks if a segment intersects a bounding box using the segment's start and end XYPos
 * return how close teh segment runs to the box centre, if it intersects
 */
export function segmentIntersectsBoundingBox(box, segStart, segEnd) {
    let pos, left, right;
    const toRect = (p1, p2) => {
        let p1_1, p2_1;
        const patternInput = ((p1_1 = p1, (p2_1 = p2, (p1_1.X <= p2_1.X) && (p1_1.Y <= p2_1.Y)))) ? [p1, p2] : [p2, p1];
        return new Rectangle(patternInput[0], patternInput[1]);
    };
    const bbBottomRight = new XYPos(box.TopLeft.X + box.W, box.TopLeft.Y + box.H);
    if (rectanglesIntersect(toRect(box.TopLeft, bbBottomRight), toRect(segStart, segEnd))) {
        return findPerpendicularDistance(segStart, segEnd, (pos = ((left = box.TopLeft, (right = bbBottomRight, new XYPos(left.X + right.X, left.Y + right.Y)))), new XYPos(pos.X * 0.5, pos.Y * 0.5)));
    }
    else {
        return undefined;
    }
}

